import React from 'react';
import { NSSelect } from 'bricks';
import { IOptionAnyValue } from 'bricks/types';
import { NO_PARKING, noParkingOption } from 'views/ProFormaTable/constants';

export interface IParkingSelectorProps {
    options: IOptionAnyValue[];
    value: IOptionAnyValue[];
    setSelectedParkingOptions: (options: IOptionAnyValue[]) => void;
    onBlur?: (event: React.FocusEvent<HTMLElement>) => void;
    className?: string;
}

const ParkingSelector = ({
    options, value, setSelectedParkingOptions, onBlur, className,
}: IParkingSelectorProps) => (
    <div className="w-100">
        <NSSelect
            isMulti
            name="parking"
            options={options}
            value={value}
            onChange={options => {
                if (!options?.length) {
                    setSelectedParkingOptions([noParkingOption]);
                    return;
                }

                const lastSelectedOption = options[options.length - 1];

                if (lastSelectedOption?.value === NO_PARKING) {
                    setSelectedParkingOptions([lastSelectedOption]);
                } else {
                    const filtered = options.filter((option: IOptionAnyValue) => option.value !== NO_PARKING);
                    setSelectedParkingOptions(filtered);
                }
            }}
            onBlur={event => onBlur && onBlur(event)}
            menuPosition="fixed"
            isClearable={false}
            className={className}
        />
    </div>
);

export default ParkingSelector;
